import { RouteObject } from 'router';

import deocumentationRoot from '@/modules/documentation/routes/root';
import documentationForms from '@/modules/documentation/routes/forms';
import documentationForResellers from '@/modules/documentation/routes/for-resellers';
import documentationLayout from '@/modules/documentation/routes/layout';

/**
 * Merges all route objects into one array. Used for ex. by navigation service to create navigation tree
 */
export const routes: Array<RouteObject> = [
	{
		key: 'home',
		path: '/',
		name: 'home',
		inNavigation: false,
		component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue')
	},
	documentationForms,
	documentationForResellers,
	documentationLayout,
	...deocumentationRoot
];
